module.exports = __webpack_public_path__ + "static/media/horarios-santa-misa-basilica-menor-virgen-coromoto.1656f86e.jpg";